import React from 'react';
import PropTypes from 'prop-types';
import { HtmlRaw, Icon, Text } from '../../../atoms';
import { Container } from '../../../gridSystem';
import { Cover, Gradient, LogoCard, LogoImg, LogoLink, Overlay } from './style';

const LogoCarousel = ({ data, title, body, background }) => {
  return (
    <>
      <Cover src={background}>
        <Overlay>
          <Container>
            <Text type="h2" mb={24}>
              {title}
            </Text>
            <Text type="b3">
              <HtmlRaw html={body} />
            </Text>
          </Container>
        </Overlay>
      </Cover>
      {data?.length > 0 && (
        <Gradient>
          <Container className="pt-0 logo-wrapper">
            {(data || []).map(({ data: { logo, link } }, index) => (
              <LogoCard key={`img-${index}`}>
                <LogoImg src={logo?.src} alt="" />
                <LogoLink href={link?.uri} target="_blank">
                  <Text type="h3.5">{link?.title}</Text>
                  <Icon type="link-external-02" size={12} />
                </LogoLink>
              </LogoCard>
            ))}
          </Container>
        </Gradient>
      )}
    </>
  );
};

LogoCarousel.propTypes = {
  data: PropTypes.array,
  title: PropTypes.string,
  body: PropTypes.string,
  background: PropTypes.string,
};

export default LogoCarousel;
